// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  register = 'register',
}

// eslint-disable-next-line no-shadow
export enum FormInputName {
  id = 'id',
  paymentType = 'paymentType',
}
